import React from 'react';
import { get } from 'lodash';
import TextInput from './TextInput';

import { useUiTheme } from 'framework/uiTheme';
import CountryDropdown from './CountryDropdown';
import UsStateDropdown from './UsStateDropdown';
import { FormFieldsData } from '../FormContext';

export interface AddressInputProps {
  source: string;
  label?: string | JSX.Element;
  countryLabel?: string;
  stateLabel?: string;
  cityLabel?: string;
  addressLine1Label?: string;
  addressLine2Label?: string;
  zipLabel?: string;
  hasAddressLine2?: boolean;
  className?: TypeOrFunction<string>;
  children?: React.ReactNode;
}

type AddressInputLayoutType = ReactComponent<any>;

const AddressInput: React.FC<AddressInputProps> = ({
  source,
  countryLabel,
  stateLabel,
  cityLabel,
  addressLine1Label = 'Address line 1',
  zipLabel = 'Zip code',
  hasAddressLine2 = false,
  addressLine2Label = 'Address line 2',
  className = '',
  children,
}) => {
  const { AddressInputLayout } = useUiTheme<AddressInputLayoutType>();

  const addressLine1Source = `${source}.addressLine1`;
  const addressLine2Source = `${source}.addressLine2`;
  const citySource = `${source}.city`;
  const stateSource = `${source}.state`;
  const zipSource = `${source}.zipCode`;
  const countrySource = `${source}.country`;

  const showIfUsSelected = (data: FormFieldsData) => get(data, countrySource) === 'United States';

  return (
    <AddressInputLayout>
      <CountryDropdown data-testid="country" label={countryLabel} source={countrySource} className={className} />
      <UsStateDropdown
        isVisible={showIfUsSelected}
        data-testid="state"
        label={stateLabel}
        source={stateSource}
        className={className}
      />
      <TextInput data-testid="city" label={cityLabel} source={citySource} className={className} />
      <TextInput
        data-testid="addressLine1"
        label={addressLine1Label}
        source={addressLine1Source}
        className={className}
      />
      {hasAddressLine2 && (
        <TextInput
          data-testid="addressLine2"
          label={addressLine2Label}
          source={addressLine2Source}
          className={className}
        />
      )}
      <TextInput data-testid="zip" label={zipLabel} source={zipSource} className={className} />
      {children}
    </AddressInputLayout>
  );
};

export default AddressInput;
